import * as React from "react";
import { useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { Col, Divider, Image, Row, Space } from "antd";
import Carousel from "react-bootstrap/Carousel";

import * as String from "../../commons/string";

import Gallery from "../Gallery";
import ItemCard from "./ItemCard";
import OptionTable from "../ruta40/OptionTable";
import OptionCar from "../ruta40/OptionCar";

import BgTableHeader from "../../assets/images/home/rent/bg_table_header.png";
import ImgDigitalKeyBrowser1 from "../../assets/images/digitalKey/digitalKey12.jpg";
import ImgDigitalKeyBrowser2 from "../../assets/images/digitalKey/digitalKey13.jpg";
import ImgDigitalKeyBrowser3 from "../../assets/images/digitalKey/digitalKey14.jpg";
import ImgDigitalKeyBrowser4 from "../../assets/images/digitalKey/digitalKey15.jpg";
import ImgDigitalKeyMobile1 from "../../assets/images/digitalKey/digitalKey11.jpg";
import ImgDigitalKeyMobile2 from "../../assets/images/digitalKey/digitalKey16.jpg";
import ImgDigitalKeyMobile3 from "../../assets/images/digitalKey/digitalKey17.jpg";
import ImgDigitalKeyMobile4 from "../../assets/images/digitalKey/digitalKey18.jpg";
import ImgEvSpecification from "../../assets/images/home/rent/ev_specification.png";
import ImgDieselSpecification from "../../assets/images/home/rent/diesel_specification.png";
import ImgLocker from "../../assets/images/home/rent/img_locker.png";
import bayrunTypeInterior1 from "../../assets/images/model/bayrun/BayrunType-interior-1.jpg";
import bayrunTypeInterior2 from "../../assets/images/model/bayrun/BayrunType-interior-2.jpg";
import bayrunTypeInterior3 from "../../assets/images/model/bayrun/BayrunType-interior-3.jpg";
import bayrunTypeInterior4 from "../../assets/images/model/bayrun/BayrunType-interior-4.jpg";
import bayrunTypeInterior5 from "../../assets/images/model/bayrun/BayrunType-interior-5.jpg";
import bayrunTypeInterior6 from "../../assets/images/model/bayrun/BayrunType-interior-6.jpg";
import bayrunTypeInterior7 from "../../assets/images/model/bayrun/BayrunType-interior-7.jpg";
import bayrunTypeInterior8 from "../../assets/images/model/bayrun/BayrunType-interior-8.jpg";
import bayrunTypeInterior9 from "../../assets/images/model/bayrun/BayrunType-interior-13.jpg";
import bayrunTypeInterior10 from "../../assets/images/model/bayrun/BayrunType-interior-14.jpg";
import bayrunTypeInterior11 from "../../assets/images/model/bayrun/BayrunType-interior-15.jpg";
import sTypeInterior1 from "../../assets/images/model/stype/SType-interior-1.jpg";
import sTypeInterior2 from "../../assets/images/model/stype/SType-interior-2.jpg";
import sTypeInterior3 from "../../assets/images/model/stype/SType-interior-3.jpg";
import dieselTypeInterior1 from "../../assets/images/model/diesel/DieselType-interior-1.jpg";
import dieselTypeInterior2 from "../../assets/images/model/diesel/DieselType-interior-2.jpg";
import dieselTypeInterior3 from "../../assets/images/model/diesel/DieselType-interior-3.jpg";
import dieselTypeInterior4 from "../../assets/images/model/diesel/DieselType-interior-4.jpg";

type InfoType = {
    title?: string;
    carType: any;
    options: any;
    specifications: any[];
    freeItems: any[];
    rentPaidItems?: any[];
};

const DetailCarInfo = ({ isB2b, info }: { isB2b?: boolean; info: InfoType }) => {
    const [price, setPrice] = useState<{ weekdayPrice: string; weekendPrice: string }>({ weekdayPrice: "199,000원", weekendPrice: "249,000원" });

    useEffect(() => {
        if (!info?.title) return;
        if (info?.title?.includes("★")) {
            setPrice({ weekdayPrice: "199,000원", weekendPrice: "199,000원" });
        }
    }, [info]);

    const getCarImages = () => {
        switch (info.carType) {
            case "sType":
                return [sTypeInterior1, sTypeInterior2, sTypeInterior3];
            case "bayrun3":
                return [bayrunTypeInterior1, bayrunTypeInterior2, bayrunTypeInterior3];
            case "bayrun4":
                return [
                    bayrunTypeInterior4,
                    bayrunTypeInterior9,
                    bayrunTypeInterior5,
                    bayrunTypeInterior6,
                    bayrunTypeInterior7,
                    bayrunTypeInterior8,
                    bayrunTypeInterior10,
                    bayrunTypeInterior11,
                ];
            case "diesel":
                return [dieselTypeInterior1, dieselTypeInterior2, dieselTypeInterior3, dieselTypeInterior4];
            default:
                return [bayrunTypeInterior4, bayrunTypeInterior5, bayrunTypeInterior6];
        }
    };

    const rentPrice = [
        { category: "weekday", title: "평일 렌트", price: price.weekdayPrice },
        { category: "weekend", title: "주말 렌트(금,토,일)", price: price.weekendPrice },
        { category: "insurance", title: "자차 보험료", price: "1만원" },
        { category: "heater", title: "무시동히터 연료비", price: "1만5천원(12월/1월/2월)\n1만원(3월/4월/10월/11월)" },
    ];

    return (
        <>
            <MobileView className="mobile">
                <Space direction="vertical" style={{ width: "100%" }} size={16}>
                    <Space direction="vertical" style={{ width: "100%" }} size={16}>
                        {getCarImages().map((image) => (
                            <Image key={image} src={image} />
                        ))}
                    </Space>
                    <Divider style={{ margin: "14px 0" }} />
                    <Space direction="vertical" style={{ width: "100%" }} size={16}>
                        <h5 className="text-center">{String.layout}</h5>
                        <OptionCar carType={info.carType} options={info.options} rent={true} />
                        <OptionTable hasDesign={true} options={info.options} />
                        {info.carType === "bayrun4" && (
                            <div className="custom-bolder-box">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0 mt-2">
                                    <li>최대 4인(성인 2명 + 어린이 2명)까지 이용 가능하며, 보다 편안한 취침을 위해 3인 이하 이용을 권장합니다.</li>
                                </ul>
                            </div>
                        )}

                        {info.carType === "diesel" && (
                            <div className="custom-bolder-box">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0 mt-2">
                                    <li>최대 3인까지 이용 가능합니다.</li>
                                </ul>
                            </div>
                        )}
                    </Space>
                    <Divider style={{ margin: "14px 0" }} />
                    {!isB2b && (
                        <>
                            <Space direction="vertical" style={{ width: "100%" }} size={16}>
                                <h5 className="text-center">{String.rentPrice}</h5>
                                <table className="table design-table">
                                    <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                        <tr>
                                            <th colSpan={2} className="text-center">
                                                1박 기준
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rentPrice.map((price, index) => (
                                            <tr key={index}>
                                                <th>{price.title}</th>
                                                <td>
                                                    {price.category === "weekend" ? (
                                                        <p>
                                                            {info.title?.includes("★") && (
                                                                <span style={{ opacity: 0.5, textDecoration: "line-through", paddingRight: 8 }}>249,000원</span>
                                                            )}
                                                            {price.price}
                                                        </p>
                                                    ) : (
                                                        <span>{price.price}</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="custom-bolder-box">
                                    <p className="text-danger text-bold">※ {String.caution}</p>
                                    <ul className="listSpace mb-0  mt-2">
                                        <li>성수기 비용은 별도 공지됩니다.</li>
                                        <li>주말(금,토,일)은 2박 3일 예약만 가능합니다.</li>
                                    </ul>
                                </div>
                            </Space>
                            <Divider style={{ margin: "14px 0" }} />
                        </>
                    )}
                    <Space direction="vertical" style={{ width: "100%" }} size={16}>
                        <h5 className="text-center">{String.freeItems}</h5>
                        <ItemCard items={info.freeItems} />
                    </Space>
                    {info.rentPaidItems && (
                        <>
                            <Divider style={{ margin: "14px 0" }} />
                            <Space direction="vertical" style={{ width: "100%" }} size={16}>
                                <h5 className="text-center">{String.paidItems}</h5>
                                <ItemCard items={info.rentPaidItems} />
                            </Space>
                        </>
                    )}
                    {!isB2b && (
                        <>
                            <Divider style={{ margin: "14px 0" }} />
                            <Space direction="vertical" style={{ width: "100%" }} size={16}>
                                <h5 className="text-center">무인 사물함 안내</h5>
                                <img className="w-100" src={ImgLocker}></img>
                                <div className="custom-bolder-box">
                                    <ul className="listSpace mb-0">
                                        <li>무인 사물함은 렌트 이용일부터 사용하실 수 있습니다.</li>
                                        <li>사물함의 비밀번호는 당일 관리자(070-4327-3730)에게 전화로 확인해 주세요.</li>
                                    </ul>
                                </div>
                            </Space>
                            <Divider style={{ margin: "14px 0" }} />
                            <Space direction="vertical" style={{ width: "100%" }} size={16}>
                                <h5 className="text-center">{String.digitalKeyService}</h5>
                                <Carousel variant="light" indicators={false} defaultValue={1}>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyMobile1} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyMobile2} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyMobile3} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyMobile4} />
                                    </Carousel.Item>
                                </Carousel>
                            </Space>
                        </>
                    )}
                    <Divider style={{ margin: "14px 0" }} />
                    <Space direction="vertical" style={{ width: "100%" }} size={16}>
                        <h5 className="text-center">{String.specificationInfo}</h5>
                        <img className="w-100" src={info.carType === "diesel" ? ImgDieselSpecification : ImgEvSpecification}></img>
                        <table className="table design-table">
                            <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                <tr>
                                    <th scope="col">{String.specificationName}</th>
                                    <td>{String.specifications}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {info.specifications.map((specification) => (
                                    <tr key={specification.th}>
                                        <th>{specification.th}</th>
                                        <td>
                                            <p>{specification.td}</p>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="custom-bolder-box">
                            <p className="text-danger text-bold">※ {String.caution}</p>
                            <ul className="listSpace mb-0 mt-2">
                                <li>
                                    {info.carType === "diesel"
                                        ? "차량 높이가 2.8m 이므로 통행 시 유의해 주세요."
                                        : "차량 높이가 3m 이므로 통행 시 유의해 주세요."}
                                </li>
                                <li>차량 무게가 약 4톤이므로, 경사로에 장기간 주차를 금지합니다.</li>
                            </ul>
                        </div>
                    </Space>
                </Space>
            </MobileView>
            <BrowserView className="browser">
                <Space direction="vertical" style={{ width: "100%" }} size={50}>
                    <Gallery images={getCarImages()} />
                    <Space direction="vertical" style={{ width: "100%" }} size={20}>
                        <h5 className="text-center">{String.layout}</h5>
                        <OptionCar carType={info.carType} options={info.options} rent={true} />
                        <OptionTable hasDesign={true} options={info.options} />
                        {info.carType === "bayrun4" && (
                            <div className="custom-bolder-box">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0  mt-2">
                                    <li>최대 4인(성인 2명 + 어린이 2명)까지 이용 가능하며, 보다 편안한 취침을 위해 3인 이하 이용을 권장합니다.</li>
                                </ul>
                            </div>
                        )}
                        {info.carType === "diesel" && (
                            <div className="custom-bolder-box">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0 mt-2">
                                    <li>최대 3인까지 이용 가능합니다.</li>
                                </ul>
                            </div>
                        )}
                    </Space>
                    {!isB2b && (
                        <Space direction="vertical" style={{ width: "100%" }} size={20}>
                            <h5 className="text-center">{String.rentPrice}</h5>
                            <table className="table design-table">
                                <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                    <tr>
                                        <th colSpan={2} className="text-center">
                                            1박 기준
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rentPrice.map((price, index) => (
                                        <tr key={index}>
                                            <th>{price.title}</th>
                                            <td>
                                                {price.category === "weekend" ? (
                                                    <p>
                                                        {info.title?.includes("★") && (
                                                            <span style={{ opacity: 0.5, textDecoration: "line-through", paddingRight: 8 }}>249,000 원</span>
                                                        )}
                                                        {price.price}
                                                    </p>
                                                ) : (
                                                    <span>{price.price}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="custom-bolder-box">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0  mt-2">
                                    <li>성수기 비용은 별도 공지됩니다.</li>
                                    <li>주말(금,토,일)은 2박 3일 예약만 가능합니다.</li>
                                </ul>
                            </div>
                        </Space>
                    )}
                    <Space direction="vertical" style={{ width: "100%" }} size={20}>
                        <h5 className="text-center">{String.freeItems}</h5>
                        <ItemCard items={info.freeItems} />
                    </Space>
                    {info.rentPaidItems && (
                        <Space direction="vertical" style={{ width: "100%" }} size={20}>
                            <h5 className="text-center">{String.paidItems}</h5>
                            <ItemCard items={info.rentPaidItems} />
                        </Space>
                    )}
                    {!isB2b && (
                        <>
                            <Space direction="vertical" style={{ width: "100%" }} size={20}>
                                <h5 className="text-center">무인 사물함 안내</h5>
                                <img width="100%" src={ImgLocker}></img>
                                <div className="custom-bolder-box">
                                    <ul className="listSpace mb-0">
                                        <li>무인 사물함은 렌트 이용일부터 사용하실 수 있습니다.</li>
                                        <li>사물함의 비밀번호는 당일 관리자(070-4327-3730)에게 전화로 확인해 주세요.</li>
                                    </ul>
                                </div>
                            </Space>
                            <Space direction="vertical" style={{ width: "100%" }} size={20}>
                                <h5 className="text-center">{String.digitalKeyService}</h5>
                                <Carousel variant="light" indicators={false} defaultValue={1}>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyBrowser1} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyBrowser2} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyBrowser3} />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img className="d-block img-fluid" src={ImgDigitalKeyBrowser4} />
                                    </Carousel.Item>
                                </Carousel>
                            </Space>
                        </>
                    )}
                    <Space direction="vertical" style={{ width: "100%" }} size={20}>
                        <h5 className="text-center">{String.specificationInfo}</h5>
                        <Row align="middle">
                            <Col span={11}>
                                <img width="100%" src={info.carType === "diesel" ? ImgDieselSpecification : ImgEvSpecification}></img>
                            </Col>
                            <Col span={13}>
                                <table className="table design-table">
                                    <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                        <tr>
                                            <th scope="col">{String.specificationName}</th>
                                            <td>{String.specifications}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {info.specifications.map((specification) => (
                                            <tr key={specification.th}>
                                                <th>{specification.th}</th>
                                                <td>
                                                    <p>{specification.td}</p>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <div className="custom-bolder-box">
                            <p className="text-danger text-bold">※ {String.caution}</p>
                            <ul className="listSpace mb-0  mt-2">
                                <li>
                                    {info.carType === "diesel"
                                        ? "차량 높이가 2.8m 이므로 통행 시 유의해 주세요."
                                        : "차량 높이가 3m 이므로 통행 시 유의해 주세요."}
                                </li>
                                <li>차량 무게가 약 4톤이므로, 경사로에 장기간 주차를 금지합니다.</li>
                            </ul>
                        </div>
                    </Space>
                </Space>
            </BrowserView>
        </>
    );
};

export default DetailCarInfo;
